import {
	performIssuePutRequest,
	performIssueDeleteRequest,
	performIssueGetRequest,
} from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';
import type { UserPreferences } from '@atlassian/jira-issue-shared-types/src/common/types/user-preferences-type.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { Value } from './types.tsx';

export const saveUserPreferenceValue = async (userPreferenceKey: UserPreferences, value: Value) =>
	performIssuePutRequest(
		`/rest/api/2/mypreferences?key=${userPreferenceKey}`,
		{
			body: value,
		},
		'user-preferences-services/src/utils',
	);

// As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
// However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
// come through Relay/Agg.
// This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
// Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
// Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
export const fetchUserPreferenceValue = async (
	userPreferenceKey: UserPreferences,
): Promise<Value> => {
	try {
		if (expVal('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
			const response = await performIssueGetRequest(
				`/rest/api/2/mypreferences?key=${userPreferenceKey}`,
				undefined,
				'user-preferences-services/src/utils',
			);
			return response;
		}
		return null;
	} catch (error) {
		// If the preference doesn't exist, return null
		return null;
	}
};

export const removeUserPreferenceValue = async (userPreferenceKey: UserPreferences) =>
	performIssueDeleteRequest(
		`/rest/api/2/mypreferences?key=${userPreferenceKey}`,
		undefined,
		'user-preferences-services/src/utils',
	);
